<template>
  <div
    class="reports--wrapper overflow-auto bg-n-background w-full px-8 xl:px-0"
  >
    <div class="max-w-[60rem] mx-auto pb-12">
      <router-view />
    </div>
  </div>
</template>

<style scoped lang="scss">
.reports--wrapper {
  :deep() {
    .multiselect--disabled {
    }

    .multiselect__content-wrapper {
    }

    .multiselect__tags {

      input[type='text'] {
      }
    }

    .multiselect__placeholder {
    }

    .multiselect__select {
    }

    .multiselect__single {
    }

    .multiselect__input {
    }

    .multiselect__tags,
    .multiselect__input,
    .multiselect {
    }

    .mx-input-wrapper {

      input {
      }
    }

    .multiselect__option {
    }

    .mx-datepicker {
      .mx-input {
        background-color: transparent !important;
      }

      .mx-input-wrapper input::placeholder {
      }

      .mx-input-wrapper input {
      }
    }

    .multiselect--active:not(.multiselect--above) .multiselect__current,
    .multiselect--active:not(.multiselect--above) .multiselect__input,
    .multiselect--active:not(.multiselect--above) .multiselect__tags {
    }
  }
}
</style>
